import { jsx, jsxs } from "react/jsx-runtime";
import { Activity, Airplay } from "@tamagui/lucide-icons";
import { Button, XGroup, XStack, YStack } from "tamagui";
function ButtonDemo(props) {
  return /* @__PURE__ */ jsxs(YStack, { padding: "$3", space: "$3", ...props, children: [
    /* @__PURE__ */ jsx(Button, { children: "Plain" }),
    /* @__PURE__ */ jsx(Button, { alignSelf: "center", icon: Airplay, size: "$6", children: "Large" }),
    /* @__PURE__ */ jsxs(XStack, { space: "$2", justifyContent: "center", children: [
      /* @__PURE__ */ jsx(Button, { size: "$3", theme: "alt2", children: "Alt2" }),
      /* @__PURE__ */ jsx(Button, { size: "$3", theme: "yellow", children: "Yellow" })
    ] }),
    /* @__PURE__ */ jsxs(XStack, { space: "$2", children: [
      /* @__PURE__ */ jsx(Button, { themeInverse: true, size: "$3", children: "Inverse" }),
      /* @__PURE__ */ jsx(Button, { iconAfter: Activity, size: "$3", children: "iconAfter" })
    ] }),
    /* @__PURE__ */ jsxs(XGroup, { children: [
      /* @__PURE__ */ jsx(XGroup.Item, { children: /* @__PURE__ */ jsx(Button, { width: "50%", size: "$2", disabled: true, opacity: 0.5, children: "disabled" }) }),
      /* @__PURE__ */ jsx(XGroup.Item, { children: /* @__PURE__ */ jsx(Button, { width: "50%", size: "$2", chromeless: true, children: "chromeless" }) })
    ] })
  ] });
}
export {
  ButtonDemo
};
//# sourceMappingURL=ButtonDemo.js.map
